const CHAT_VIEW_STORAGE_KEY = 'disha-chat-view-state';
const CHAT_BASE_PATH = '/disha-chat';

export function saveChatViewState(state) {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(CHAT_VIEW_STORAGE_KEY, JSON.stringify(state));
}

export function loadChatViewState() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(CHAT_VIEW_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function buildChatUrl({
  conversationId = null,
  aiChatActive = false,
  pendingUserId = null,
  taskId = null
} = {}) {
  const params = new URLSearchParams();

  if (taskId) {
    params.set('task', String(taskId));
  }

  if (conversationId) {
    params.set('conversation', String(conversationId));
  } else if (pendingUserId) {
    params.set('pendingUser', String(pendingUserId));
  } else if (aiChatActive) {
    params.set('ai', '1');
  }

  const qs = params.toString();
  return qs ? `${CHAT_BASE_PATH}?${qs}` : CHAT_BASE_PATH;
}

export function parseChatSearchParams(query = {}) {
  const get = key => {
    if (query && typeof query.get === 'function') return query.get(key);
    const val = query?.[key];
    return Array.isArray(val) ? val[0] : val ?? null;
  };

  return {
    conversationId: get('conversation'),
    pendingUserId: get('pendingUser'),
    aiChatActive: get('ai') === '1' || get('ai') === 1,
    taskId: get('task')
  };
}

export function buildTaskDetailUrlFromChat(ticketId, chatState = {}) {
  const returnTo = buildChatUrl(chatState);
  const params = new URLSearchParams({ returnTo });
  return `/tasks/${ticketId}?${params.toString()}`;
}

export function hasChatViewParams(query = {}) {
  if (query && typeof query.has === 'function') {
    return query.has('conversation') || query.has('pendingUser') || query.has('ai');
  }
  return (
    (query.conversation != null && query.conversation !== '') ||
    (query.pendingUser != null && query.pendingUser !== '') ||
    (query.ai != null && query.ai !== '')
  );
}

export { CHAT_BASE_PATH, CHAT_VIEW_STORAGE_KEY };
